import { app } from '../../../app';
import { Controller } from './reset-password.controller';

app.component('resetPassword', {
    bindings:{appData:'<'},
    controller: Controller,
    templateUrl: require('./reset-password.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/public/reset-password/reset-password.component.js